import { Pipe, PipeTransform } from '@angular/core';
import { getBaseUrl } from '@fleet-beat/core';
import { AnimationOptions } from 'ngx-lottie';

@Pipe({
  name: 'getLoaderJsonPipe',
})
export class GetLoaderJsonPipe implements PipeTransform {
  transform(type: 'spinner' | 'loader'): AnimationOptions {
    return {
      path: `${getBaseUrl()}/libs/core/src/lib/modules/loader/assets/${type}.json`,
    };
  }
}
